import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { StripeService } from 'src/app/services/stripe.service';
import { AuthService } from 'src/services/auth/auth.service';

export interface SubscriptionSuccessDialogData {
  data: {
    sessionId: string;
  };
}

@Component({
  selector: 'subscription-success-dialog',
  standalone: true,
  imports: [CommonModule, MatProgressSpinner, MatButtonModule, MatIconModule],
  templateUrl: './subscription-success-dialog.component.html',
  styleUrl: './subscription-success-dialog.component.scss',
})
export class SubscriptionSuccessDialogComponent implements OnInit {
  isLoading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SubscriptionSuccessDialogData,
    public matDialogRef: MatDialogRef<SubscriptionSuccessDialogComponent>,
    private stripeService: StripeService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    try {
      this.fetchSubscription();
      this.isLoading = false;

      this.showConfetti();
    } catch (e) {
      this.matDialogRef.close();
    }
  }

  public showConfetti() {
    // @ts-ignore
    window.confetti({
      particleCount: 100,
      spread: 360,
      // origin: { x: 0.5, y: 1 },
    });
  }

  fetchSubscription() {
    if (!!this.authService.user?.uid) {
      // const sub = await this.stripeService.getSubscription(
      // this.authService.user.uid
      // );
    } else {
      throw new Error('User not logged in');
    }
  }
}
